import React from 'react';
import logo from '../../assets/images/logo-tgle-blanco.png';

const MessageSplash=({message})=>{
    return (
        <div className='Splash'>
            <img src={logo} alt='Logo' className='splash-logo'/>
            <h1>{message}</h1>
        </div>
    );
};

export default MessageSplash;
